'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keyToCmp = keyToCmp;
exports.identityPredicate = identityPredicate;
exports.numberIdentity = numberIdentity;
exports.primitiveIdentity = primitiveIdentity;
//  strict

function keyToCmp(keyFn) {
    return function (a, b) {
        var ka = keyFn(a);
        var kb = keyFn(b);
        // istanbul ignore else
        if (typeof ka === 'boolean' && typeof kb === 'boolean') {
            return ka === kb ? 0 : !ka && kb ? -1 : 1;
        } else if (typeof ka === 'number' && typeof kb === 'number') {
            return ka - kb;
        } else if (typeof ka === 'string' && typeof kb === 'string') {
            return ka === kb ? 0 : ka < kb ? -1 : 1;
        } else {
            return -1;
        }
    };
}

function identityPredicate(x) {
    return !!x;
}

function numberIdentity(x) {
    /* istanbul ignore if */
    if (typeof x !== 'number') {
        // eslint-disable-next-line no-console
        console.error('Inputs must be numbers, got', x);
        throw new Error('Inputs must be numbers');
    }
    return x;
}

function primitiveIdentity(x) {
    /* istanbul ignore if */
    if (typeof x !== 'string' && typeof x !== 'number' && typeof x !== 'boolean') {
        throw new Error('Please provide a key function that can establish object identity');
    }
    return x;
}